module.exports = __webpack_public_path__ + "img/core-values-2.22376c53.svg";